import React from "react"

function Info(props) {
  return (
    <div className="info">
      <h1 className="subtitle description">
        DiskMate for macOS will eject all removable drives with one click.
        If you have a MacBook or a MacBook Pro and 
        you happen to undock often in your workflow, then DiskMate is a must.
      </h1>
    </div>
  )
}

export default Info
